import React from 'react';
import {Card, Image, Stack, CardBody, Heading, Text, GridItem, useBreakpointValue, CardFooter} from '@chakra-ui/react'; // Import relevant components
import {Link} from 'react-router-dom'; // For routing
import PropTypes from 'prop-types';

const CardHorizontal = ({cardData}) => {

    CardHorizontal.propTypes = {
        cardData: PropTypes.shape({
            id: PropTypes.number.isRequired,
            smallTitle: PropTypes.string.isRequired,
            mainTitle: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            image: PropTypes.string.isRequired,
            linkLabel: PropTypes.string
        }),
    };

    const isMobile = useBreakpointValue({base: true, md: false});

    const image =
        <GridItem colStart={isMobile ? 1 : 6} colEnd={10}>
            <Image
                objectFit="cover"
                maxW={{base: '100%'}}
                src={cardData.image}
                alt="image"
                width="100%"
            />
        </GridItem>


    return (
        <Card
            direction={{base: 'column', sm: 'row'}}
            overflow="hidden"
            variant="outline"
            width={'fit-content'}
            borderWidth="0"
            className='grid-div-10-col column-1-10'
            mt={isMobile ? "116px" : "103px"}
            mb={isMobile ? "116px" : "221px"}
        >
            {isMobile && image}
            <GridItem colStart={isMobile ? 1 : 2} colEnd={6} >
                <Stack>
                    <CardBody p={0} mt={isMobile ? "24px": "0"} >
                        <Text py="0" textStyle="labelBeforeTitle">{cardData.smallTitle}</Text>
                        <Heading variant="heading4">{cardData.mainTitle}</Heading>
                        <Text py="2" textStyle="customBodyMedium">
                            {cardData.description}
                        </Text>
                    </CardBody>
                    <CardFooter mt="36px">
                        <Link to={`seemore/${cardData.id}`} className="linkTo">{cardData.linkLabel}</Link>
                    </CardFooter>
                </Stack>
            </GridItem>
            {!isMobile && image}
        </Card>
    );
};

export default CardHorizontal;